module.exports = __webpack_public_path__ + "img/investment-plan-mobile.5aed2113.webp";